// extracted by mini-css-extract-plugin
module.exports = {"paperContainer":"BillerProfile_paperContainer__3duOI","title":"BillerProfile_title__3Su5L","mainContainer":"BillerProfile_mainContainer__AcHkB"};